<template>
	<p-card class="job-valuation-summary-table" style="padding: 0; overflow: hidden">
		<div class="tw-flex">
			<div class="job-valuation-summary-table-left-col">
				<summary-table-header-description />
				<div>
					<div v-for="appraiser in appraisers" class="job-valuation-summary-cell">
						{{ appraiser.name }}
					</div>
				</div>
			</div>

			<div class="tw-flex-auto job-valuation-summary-table-middle-col">
				<div class="job-valuation-summary-table-header-jobs tw-flex">
					<div v-for="jobName in jobNames" class="job-valuation-summary-table-header-job-name tw-flex tw-text-center tw-items-center text-primary">
						{{ jobName }}
					</div>
				</div>
				<div>
					<div v-for="valuationRow in valuations" class="tw-flex ">
						<div v-for="valuation in valuationRow" class="job-valuation-summary-cell" style="min-width: 160px;max-width: 160px;">
							{{ valuation.average }}
						</div>
					</div>
				</div>
			</div>

			<div class="job-valuation-summary-table-right-col">
				<summary-table-header-cell>
					<span class="text-primary">ACCIONES</span>
				</summary-table-header-cell>
			<div v-for="appraiser in appraisers" class="job-valuation-summary-cell">
				<envelope-icon
					:class="{ 'envelope-disabled': appraiser.evaluationState === 2, 'cursor-pointer': appraiser.evaluationState !== 2 }"
					@click="appraiser.evaluationState !== 2 && $emit('sendEmailClick', appraiser)"
				/>
			</div>
			</div>
		</div>
		<div class="job-valuation-summary-table-footer tw-flex">
			<div class="job-valuation-summary-table-footer-average tw-flex tw-justify-center tw-items-center text-lg text-white">
				PROMEDIOS
			</div>
			<div class="tw-flex overflow-y">
				<div v-for="avarageRow in avarages" style="min-width: 160px;max-width: 160px;" class="job-valuation-summary-table-footer-averages">
						{{ avarageRow }}
				</div>
			</div>
			<div class="job-valuation-summary-table-footer-average-empty">
			</div>
		</div>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import SummaryTableHeaderDescription
	from '@/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table/summary-table-header-description';
import SummaryTableHeaderCell
	from '@/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table/summary-table-header-cell';
import EnvelopeIcon from '@/modules/shared/components/icons/envelope-icon';

export default {
	name: 'job-valuation-summary-table',
	components: { EnvelopeIcon, SummaryTableHeaderCell, SummaryTableHeaderDescription, PCard },
	props: {
		jobNames: {
			type: Array,
			default: () => [],
		},
		appraisers: {
			type: Array,
			default: () => [],
		},
		valuations: {
			type: Array,
			default: () => [],
		},
		avarages: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.job-valuation-summary-table {
	.job-valuation-summary-table-left-col {
		min-width: 200px;
		max-width: 200px;
		border-right: 1px solid var(--app-color-primary);
	}
	.job-valuation-summary-table-middle-col {
		width: calc(100% - 350px);
		overflow-y: auto;
	}
	.job-valuation-summary-table-right-col {
		min-width: 150px;
		max-width: 150px;
		border-left: 1px solid var(--app-color-primary);
	}
	.job-valuation-summary-cell {
		color: var(--app-color-info);
		padding: 5px 10px;
		min-height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #dddddd;
	}
	.job-valuation-summary-table-header-jobs {
		height: 80px;
		.job-valuation-summary-table-header-job-name {
			display: flex;
			justify-content: center;
			min-width: 160px;
			max-width: 160px;
			padding: 5px 20px;
			border-bottom: 1px solid #dddddd;
		}
	}


	.job-valuation-summary-table-footer {
		.job-valuation-summary-table-footer-average {
			min-width: 200px;
			max-width: 200px;
			background-color: var(--app-color-primary);
			height: 60px;
		}
		.job-valuation-summary-table-footer-averages {
			align-items: center;
			background-color: #f4f4f4;
			color: #f09c2b;
			display: flex;
			justify-content: center;
			font-family: font(bold);
			font-size: 18px;
			padding: 5px 10px;
		}
		.job-valuation-summary-table-footer-average-empty {
			min-width: 150px;
			max-width: 150px;
			height: 60px;
			background-color: #f4f4f4;
		}
	}
}

.overflow-y {
	overflow-y: auto;
}

.envelope-disabled {
	opacity: 0.3;
	pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table.vue